import {useLoaderData, useLocation} from "@remix-run/react";
import React, {useEffect, useState} from "react";
import {theme} from "../../styles/theme.js";
import {getUrlParamsToString} from "../../utils/sections/search/index.js";
import {Link} from "../link/index.jsx";
import ArrowLeft from "../svgicon/ArrowLeft.jsx";
import ArrowRight from "../svgicon/ArrowRight.jsx";
import {
  ArrowLeftWrapper,
  ArrowRightWrapper,
  GreyLine,
  PageItem,
  PaginationWrapper,
} from "./styles.js";

const ArticlePagination = ({currentPage, totalPages, onPageChange}) => {
  const data = useLoaderData();
  const location = useLocation();
  const oldSearchParams = new URLSearchParams(location.search);

  const handleRightArrowClick = () => {
    if (currentPage !== totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLeftArrowClick = () => {
    if (currentPage !== 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleArrowKeyDown = (e, direction) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      direction === "left" ? handleLeftArrowClick() : handleRightArrowClick();
    }
  };
  return (
    <PaginationWrapper>
      <ArrowLeftWrapper
        active={currentPage > 1}
        onClick={handleLeftArrowClick}
        onKeyDown={(e) => handleArrowKeyDown(e, "left")}
      >
        <ArrowLeft
          active={currentPage > 1}
          width={12}
          height={14}
          color={
            currentPage === 1 ? theme?.colors?.primaryGrey : theme?.colors?.primaryBlue
          }
        />
      </ArrowLeftWrapper>
      {data?.pagination?.length &&
        data?.pagination.map((page, i) => (
          <a
            key={i}
            style={{all: "unset"}}
            href={
              typeof page === "string"
                ? ""
                : `${getUrlParamsToString(
                    {...data?.paginationLink?.queryParams, currentPage: page},
                    oldSearchParams,
                  )}`
            }
            onClick={(e) => {
              e.preventDefault();
              typeof page === "number" && onPageChange(page);
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <PageItem key={`${page}-${i}`} isActive={currentPage === page}>
                {page}
              </PageItem>
              {data?.pagination.length - 1 !== i && <GreyLine />}
            </div>
          </a>
        ))}

      <ArrowRightWrapper
        active={currentPage < totalPages}
        onClick={handleRightArrowClick}
        onKeyDown={(e) => handleArrowKeyDown(e, "right")}
      >
        <ArrowRight
          active={currentPage < totalPages}
          width={12}
          height={14}
          color={
            currentPage === totalPages
              ? theme?.colors?.primaryGrey
              : theme?.colors?.primaryBlue
          }
        />
      </ArrowRightWrapper>
    </PaginationWrapper>
  );
};

export default ArticlePagination;
